import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../utils/checkout';
import { useCountdown } from './Countdown';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const {
    minutes,
    seconds
  } = useCountdown();
  useEffect(() => {
    const target = document.getElementById('hero-cta');
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-31" data-mp="2avkzkqmo4n0z">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold-500/25 bg-navy-950/95 px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-2.5 backdrop-blur" data-id="element-32" data-mp="2aus26g9ln9vi">
          <div className="mx-auto flex max-w-3xl flex-col items-center gap-2 sm:flex-row sm:justify-between" data-id="element-33" data-mp="333swq9r4tkzi">
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-white/70" data-id="element-34" data-mp="2pbcydm96eb4x">
              Offer ends in{' '}
              <span className="tabular-nums text-gold-400" data-id="element-35" data-mp="2u9ejecq5wkj1">
                {minutes}:{seconds}
              </span>
            </p>
            <a href={CHECKOUT_URL} className="animate-cms-shake flex w-full items-center justify-center rounded-xl bg-gold-500 px-4 py-3 text-sm font-extrabold uppercase tracking-wide text-navy-950 shadow-gold transition-colors duration-200 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:w-auto sm:px-7" data-id="element-36" data-mp="2kctavhexorag">
              I want the system — $27
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}